import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
    selector: 'tidy-accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss'],
    animations: [
        trigger('openClose', [
            state('open', style({
                height: '*',
                opacity: 1,
                visibility: 'visible',
                padding: '16px'
            })),
            state('closed', style({
                height: '0',
                opacity: 0,
                visibility: 'hidden',
                padding: '0px'
            })),
            transition('open => closed', [
                animate('0.1s ease-out')
            ]),
            transition('closed => open', [
                animate('0.1s ease-in')
            ])
        ])
    ],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccordionComponent {
  @Input() title = '';
  @Input() icon = '';
  @Input() isOpen = false;
  @Input() content: any;
  @Input() hasUnreadMessages = false;
  @Output() toggleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() accordionHover: EventEmitter<boolean> = new EventEmitter<boolean>();

  onToggle() {
    this.isOpen = !this.isOpen;
    this.toggleChange.emit(this.isOpen);
  }

  onHover(event: any) {
    this.accordionHover.emit(event);
  }
}
